/* eslint-disable */
import React, {useEffect, useState} from 'react'
import Modal from 'react-modal';
import styled from 'styled-components';
import TextInput from 'components/TextInput';
import ButtonV2 from 'components/ButtonV2';
import ButtonSecondary from 'components/ButtonSecondary';
import FeatherIcon from 'feather-icons-react';
import {Link, useHistory} from 'react-router-dom';
import DropdownV3 from 'components/DropdownV3';

import { listLanguage, categoryTemplate } from '../ListDropdownData';

// api
import applicationSvc from "services/applicationSvc";
import waTemplateSvc from "services/waTemplateSvc";

// style
import './FormCreateTemplate.scss'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    padding: 0,
    minWidth: '600px'
  },
};

function OnBoarding(props) {
  const {isModalAddTemplate,setModalAddTemplate} = props;
  const initialValidation2 = {
    templateName: { isValid: true, msg: "" },
    category: { isValid: true, msg: "" },
    language: { isValid: true, msg: "" }
  };
  const initialForm2 = {
    templateName: "",
    category: "",
    language: [],
  };
  const [isListLanguage, setListLanguage] = useState([])
  const [isSelectedLanguage, seSelectedLanguage] = useState([])
  const [isCategoryTemplate, setCategoryTemplate] = useState([])
  const [chekedId, setChekedId] = useState('')
  const [form2, setForm2] = useState(initialForm2);
  const [validation2, setValidation2] = useState();
  const [isApplicatoinId, setApplicationId] = useState([]);
  const [isErrorTemplateName, setErrorTemplateName] = useState(false);
  const [isTemplate_name, setTemplate_name] = useState("");
  const [timer, setTimer] = useState(null)
  const history = useHistory();

  useEffect(() => {
    if (!form2) {
      setForm2(initialForm2);
      
      setValidation2(initialValidation2);
    }

    setListLanguage(listLanguage)
    setCategoryTemplate(categoryTemplate)

    // Hit API
    getAllDataApplication();
  }, [])

  const changeInput = (value) =>{
    setForm2({...form2, category: value})
    setChekedId(value.value)
  }

  function closeModal() {
    setModalAddTemplate({show: false, payload: []})
  }

  // Integration
  async function getAllDataApplication() {
    let res = await applicationSvc.getAll();

    if (res.data.data) {
      let data = [];
      res?.data?.data.forEach((element) => {
        data.push(element._id);
      });
      setApplicationId(data);
    }
  }

  function handleSearch(e) {
    delayedQuery(
      e
      .replace(/ /g, "_")
      .replace(/[^a-zA-Z0-9_]/g, "")
      .toLowerCase()
    );
  }
  
  const delayedQuery = async (q) => {
    setTemplate_name(q);
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {
      onCheckTemplate(q)
    }, 500)
  
    setTimer(newTimer)
  }

  function checkValidName(ev) {
    setTemplate_name(
      ev
        .replace(/ /g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .toLowerCase()
    );
  }

  async function onCheckTemplate(ev) {
    if (ev) {
      await waTemplateSvc
        .getTemplateName(ev, isApplicatoinId[0])
        .then((result) => {
          if (result.data.data.available) {
            setErrorTemplateName(false);
          } else {
            setErrorTemplateName(true);
          }
        })
        .catch((error) => { });
    }
  }

  function handleSaveModal(){

    const isValidate = validationCreate();
    if (!isValidate) {
      return;
    }

    if(isValidate){
      form2.language = isSelectedLanguage;
      form2.templateName = isTemplate_name;
      form2.wabaID = isModalAddTemplate.payload.value;
      const dataChooseTypeTemplate = form2;
      
      history.push({
        pathname: '/whatsapp-template/create',
        state: { dataChooseTypeTemplate },
        // state: { dataDetailApp: data },
      })
      setModalAddTemplate(false)
      // handleSaveAction(isInfoSelected)
    }
  }

  const validationCreate = () => {
    let validationForm2 = initialValidation2;
    
    const { category, language } = form2;

    // required rules
    if (!isTemplate_name) {
      validationForm2 = {
        ...validationForm2,
        templateName: { ...validationForm2.templateName, isValid: false, msg: "Template Name is required" },
      };
    }
    if (!category) {
      validationForm2 = {
        ...validationForm2,
        category: { ...validationForm2.category, isValid: false, msg: "Category is required" },
      };
    }
    if (isSelectedLanguage.length<1) {
      validationForm2 = {
        ...validationForm2,
        language: { ...validationForm2.language, isValid: false, msg: "Language is required" },
      };
    }

    setValidation2(validationForm2);

    let result = true;
    Object.entries(validationForm2).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
    });
    return result;
  }

  return (
    <div>
      <Modal
        isOpen={isModalAddTemplate.show}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
      <div>
        <div className='d-flex align-items-center justify-content-between wa_title_modal px-4 py-3'>
          <h3 className='fsize-20 cl-neutral500 fweight-600 mb-0'>New Whatsapp Template</h3>
          <div className="cursor-pointer" onClick={closeModal}>
            <FeatherIcon icon="x" />
          </div>
        </div>
          <div className="px-4 py-3">
            <div className='content mb-4'>
              <div className='form-group'>
                <label className='fsize-16 fweight-600 cl-weight-grey d-block mb-2'>
                  Template Name
                </label>
                <input 
                  value={isTemplate_name}
                  onChange={(e) => handleSearch(e.target.value)}
                  // onChange={(e) => checkValidName(e.target.value)}
                  // onKeyUp={(e) => onCheckTemplate(e.target.value)}
                  type='text' 
                  className='cl-dark-grey fsize-14 fweight-400 form-control' 
                  placeholder='Template Name...' 
                />
                {isErrorTemplateName && 
                <span className="cl-red fsize-12 fweight-400 mt-1">
                  Template name is already used. Please use other template name!
                </span>
                }
              </div>
              <div className='form-group mb-4'>
                <label className='fsize-16 fweight-600 cl-weight-grey d-block mb-2'>
                  Language
                </label>
                 <DropdownV3 
                  className="padding_language"
                  isListSearch={isListLanguage} 
                  setSelectedSearch={seSelectedLanguage} 
                  isSelected={isSelectedLanguage}
                  placeholder="Select Language"
                  useSearch
                />
              </div>
              {isCategoryTemplate && isCategoryTemplate.map((item, index) => {
                return <div onClick={()=>changeInput(item)}  className={`box_linked cursor-pointer mb-3 ${item.value === chekedId && 'active_border'}`} key={index}>
                  <div className={`d-flex flex-column`}>
                    <div className="check-radio-custom elipsis_custom d-flex align-items-center fweight-600 fsize-16 cl-grey-black break-word mb-2">
                      <input
                        onChange={()=>changeInput(item)} 
                        // value={item.id}
                        checked={item.value === chekedId}
                        key={item.value}
                        type="radio" 
                        name={item.value} 
                        className={`mr-10-desktop`}
                      />
                      <label 
                        className={`mr-10-desktop small fweight-600 fsize-16 cl-grey-black`}
                        htmlFor="custom-time"
                      >
                        {item.name}
                      </label>
                    </div>
                    <p className={`ms-4 fweight-400 fsize-12 cl-grey mb-2 ps-1`}>{item.description}</p>
                  </div>
                </div>
              })}
            </div>
            <div className='d-flex align-items-center justify-content-end w-45 ms-auto'>
              <ButtonSecondary 
                handleRoute={closeModal}
                backgroundColor="#f4f5f7"
                textColor="#97A0AF"
                padding=".360rem 1rem"
                noBorder
              >
                Cancel
              </ButtonSecondary>
              <ButtonV2 
                className='ms-2'
                handleRoute={handleSaveModal} 
                backgroundColor="#3B3B47"
                textColor="#FFFFFF"
                padding=".360rem 1rem"
              >
                Continue
                </ButtonV2>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default OnBoarding